import React, { memo } from 'react';
import { NavLink } from 'react-router-dom';
import PropTypes from 'prop-types';
import './css/Events1.css';

const EventsNavBar1 = (props) => {
    const { children } = props;

    const SCHEDULE_NAVLINKS = [
        { title: 'Upcoming', link: '/events/upcoming' },
        { title: 'Past', link: '/events/past' },
    ];

    return (
        <>
            <div className="events1-nav-items full-width">
                {SCHEDULE_NAVLINKS.map((item) => {
                    return (
                        <React.Fragment key={item.title}>
                            <NavLink
                                activeClassName="events1-active-nav-item condensed-font-family font-size-3xl m-t-0 m-b-20px p-r-20px text-uppercase text-no-underline"
                                className="events1-nav-item condensed-font-family font-size-3xl m-t-0 m-b-20px p-r-20px text-uppercase text-no-underline"
                                to={item.link}
                                exact
                            >
                                <p className="m-t-0 m-b-0">{item.title}</p>
                            </NavLink>
                        </React.Fragment>
                    );
                })}
            </div>
            {children}
        </>
    );
};

EventsNavBar1.propTypes = {
    children: PropTypes.node.isRequired,
};

export default memo(EventsNavBar1);
